export default __webpack_public_path__ + "static/media/dotted_line.ee983c1d.svg";